import { Sidebar } from 'primereact/sidebar';
import FormInput from '../../../../components/Form/FormInput';
import { ListBox } from 'primereact/listbox';
import { getConstant } from '../../../../utils/constants';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';

function RelatedResourcesManager({
  isOpen,
  onClose,
  objects,
  selectedObjects,
  setSelectedObjects,
  nameOfObject,
  handleValidate
}) {
  const itemTemplate = (option) => {
    return (
      <div className="flex flex-col align-items-center gap-2 pb-2 w-full">
        <div className="font-bold">{option.title}</div>
        <div className="flex flex-row gap-x-2 items-center flex-wrap ">
          <Tag
            tag={{
              label: getConstant('solarys.resourceThemes', option.theme).label,
              icon: 'star',
              bgColor: 'bg-orange-600'
            }}
          />
          <div>
            {option.public_list.map((o, key) => (
              <Tag
                key={key}
                tag={{
                  label: o.label,
                  icon: 'man',
                  bgColor: 'bg-yellow-500'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`Ajouter des ${nameOfObject}`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput label={nameOfObject}>
            <div className="card flex justify-content-center">
              <ListBox
                value={selectedObjects}
                onChange={(e) => setSelectedObjects(e.value)}
                options={objects}
                optionLabel="title"
                itemTemplate={itemTemplate}
                className="w-full md:w-14rem"
                multiple
                filter
              />
            </div>
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default RelatedResourcesManager;
